/*
 * This file is modeled on the Blueprint common/intent file.
 * https://github.com/palantir/blueprint/blob/develop/packages/core/src/common/intent.ts
 *
 * We're using it to add additional intent constants to the BP object.
 */
let _require = require( '@nackle-bp/core' ),
    Intent = _require.Intent;

Intent.INFO = 'info';
module.exports = {
  Intent: Intent
};